// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Dlhk","name":"Header_name__1wgI8","birthday":"Header_birthday__2eTrc","skeleton":"Header_skeleton__1Ipgy"};